import React from "react";
import { Link } from "react-router-dom";
import "./AboutSection.css";
import aboutImg from "../assets/images/entrada.jpg";

const AboutSection = () => {
  return (
    <section className="about-section" id="nosotros">
      <div className="about-container">
        <div className="about-text">
          <h2>Bienvenidos <br>
          </br>I.E.S.T.P Juan Velasco Alvarado</h2>
          <p>
            Es un honor dirigirme a ustedes como Directora de esta institución que, 
            durante 33 años, ha brindado educación técnica de calidad al servicio de 
            nuestra sociedad. En nuestra institución formamos a técnicos de primer 
            nivel que respondan a las demandas del mercado laboral, adaptándonos 
            continuamente a los avances en ciencia y tecnología.
          </p>
          <p>
            Nos enorgullece ser líderes en Lima Sur y damos una cordial bienvenida a 
            nuestros futuros estudiantes, deseándoles el mayor de los éxitos en su 
            camino académico y profesional. Agradecemos su confianza en el Instituto 
            de Educación Superior Tecnológico Público «Juan Velasco Alvarado». 
            Estamos aquí para apoyarlos y guiarlos hacia un futuro prometedor.
          </p>
         <div className="director-info">
            <Link to="/director" className="director-name">
              Elsa Mary Castilla Almeyda
            </Link>
            <p className="director-title">Dirección General</p>
          </div>

        </div>
        <div className="about-image">
          <img src={aboutImg} alt="Instituto Gilda Ballivián" />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
